import React, { useEffect, useState } from 'react';
import { connect } from 'react-redux';
import { Button } from 'react-bootstrap';
import { UpdateSuccessfullyIcon } from '../components/icons/UpdateSuccessfullyIcon.jsx';
import { LoaderIcon } from '../components/icons/LoaderIcon.jsx';
import { retrieveProject } from '../modules/projects.js';

const mapDispatchToProps = { retrieveProject };

const ImportDataProgressContainer = ({
  projectId,
  status,
  retrieveProject,
}) => {
  const [show, setShow] = useState(false);

  useEffect(() => {
    let timeout = null;

    if (status) {
      setShow(true);
      timeout = setTimeout(() => retrieveProject(projectId), 20000);
    } else if (!status) {
      clearTimeout(timeout);
    }

    return () => clearTimeout(timeout);
  }, [projectId, status]);

  if (!projectId || !status) return null;
  if (!show) return null;
  return (
    <div className="banner banner-absolute">
      {status ? (
        <div className="flex flex-col flex-align-center content">
          <div className="icon animated m-b-24">
            <LoaderIcon />
          </div>
          <h4 className="m-b-24">Importing your data</h4>
          <div className="text-center text-muted">
            We're currently processing your CSV file(s) and updating all <br />{' '}
            related objects in the system.
          </div>
        </div>
      ) : (
        <div className="flex flex-col flex-align-center content">
          <div className="icon m-b-24">
            <UpdateSuccessfullyIcon />
          </div>
          <h4 className="m-b-24">Data Import Successfully Completed</h4>
          <div className="text-center text-muted m-b-30">
            Your data has been successfully imported, and all related <br />{' '}
            pages have been updated.
          </div>
          <div style={{ padding: '0 30px' }}>
            <Button
              className="btn btn-primary"
              onClick={() => window.location.reload()}
            >
              Refresh Page
            </Button>
          </div>
        </div>
      )}
    </div>
  );
};

export default connect(null, mapDispatchToProps)(ImportDataProgressContainer);
